import store from "System/reduxStore";
import { backendPy } from "System/system";
import md5 from "md5";
import { canonicals } from "Data/canonicals.js";

// -------------------------------------------------------
// -------------------------------------------------------
export const partitionFiles = (allfiles) => async (dispatch) => {
  const isEqual = (a, b) => {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  const memberOf = (header, collections) => {
    for (var ii = 0; ii < collections.length; ii++) {
      if (isEqual(collections[ii].header, header)) return ii;
    }
    return null;
  };

  allfiles = allfiles.filter((file) => file.ext === "CSV");
  const files = JSON.stringify(allfiles.map((x) => x.name));
  const paths = JSON.stringify(allfiles.map((x) => x.path.replace(/\./g, "")));
  const cuts = JSON.stringify(allfiles.map((x) => x.cut));

  const result = await backendPy("headers", "get_headers_multiple", {
    files,
    paths,
    cuts,
  });

  if (result.data) {
    const { headers } = result.data;
    const collections = [];
    for (var i = 0; i < allfiles.length; i++) {
      const header = headers[i];
      const index = memberOf(header, collections);
      if (index === null) {
        collections.push({
          title: "Group " + (collections.length + 1),
          fileids: [allfiles[i].id],
          header,
          id: md5(Date.now() + Math.random() + allfiles[i].id),
        });
      } else {
        collections[index].fileids.push(allfiles[i].id);
      }
    }

    dispatch({ type: "SET_COLLECTIONS", collections });
    console.log("Collections", collections);
    if (collections.length > 0) {
      dispatch({
        type: "SET_CURRENT_COLLECTION",
        current: collections[0].id,
      });
    }
  }
};

// -------------------------------------------------------
// -------------------------------------------------------
export const eraseCollection = (collectionid) => (dispatch) => {
  dispatch({ type: "ERASE_COLLECTION", collectionid });
  //dispatch(saveProject());
};

// -------------------------------------------------------
// -------------------------------------------------------
export const addCustomColumn = (collectionid) => (dispatch) => {
  dispatch({ type: "ADD_CUSTOM_COLUMN", collectionid });
  //dispatch(saveProject());
};

// -------------------------------------------------------
// -------------------------------------------------------
export const updateCustomColumn =
  (collectionid, index, key, value) => (dispatch) => {
    dispatch({ type: "UPDATE_CUSTOM_COLUMN", collectionid, index, key, value });
    //dispatch(saveProject());
  };

// -------------------------------------------------------
// -------------------------------------------------------
export const eraseCustomColumn = (collectionid, index) => (dispatch) => {
  dispatch({ type: "ERASE_CUSTOM_COLUMN", collectionid, index });
  //dispatch(saveProject());
};

// -------------------------------------------------------
// -------------------------------------------------------
export const updateCanonical =
  (collectionid, canonical, header) => (dispatch) => {
    dispatch({ type: "UPDATE_CANONICAL", collectionid, canonical, header });
    //dispatch(saveProject());
  };

// -------------------------------------------------------
// -------------------------------------------------------
export const removeCanonical = (collectionid, header) => (dispatch) => {
  dispatch({ type: "REMOVE_CANONICAL", collectionid, header });
  //dispatch(saveProject());
};

// -------------------------------------------------------
// -------------------------------------------------------
export const includeCollection = (collectionid, cb) => async (dispatch) => {
  const { repository, collections, id, datapath } = store.getState().project;
  const projectid = id;

  
  const cols = getBundleCols(collectionid);

  const collection = collections.find((x) => x.id === collectionid);
  const allfiles = collection.fileids
    .map((id) => repository[id])
    .filter((file) => file.ext === "CSV");
  const files = JSON.stringify(allfiles.map((x) => x.name));
  const paths = JSON.stringify(allfiles.map((x) => x.path.replace(/\./g, "")));
  const cuts = JSON.stringify(allfiles.map((x) => x.cut));

  const bundle = {
    projectid,
    collectionid: collection.id,
    collectionTitle: collection.title,
    cols,
    files,
    paths,
    cuts,
  };

  await backendPy("collections", "build_single", {
    bundle: JSON.stringify(bundle),
    datapath,
  });

  console.log("Completed build_single");

  dispatch({ type: "INCLUDE_COLLECTION", collectionid });
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const getBundleCols = (collectionid) => {
  const { collections } = store.getState().project;
  const collection = collections.find((x) => x.id === collectionid);

  const mapping = collection.mapping || {};
  const reverseMapping = Object.keys(mapping).reduce((acc, key) => {
    acc[mapping[key]] = key;
    return acc;
  }, {});

  const custom = collection.custom || [];
  const customCols = custom.map((x) => x.key);

  const cols = [];
  for (const canonical of canonicals) {
    const mapType = reverseMapping.hasOwnProperty(canonical.header)
      ? "map"
      : "none";
    const mappedTo = reverseMapping[canonical.header];
    const isCustom = customCols.includes(mappedTo);
    const mappedValue = isCustom
      ? custom.find((x) => x.key === mappedTo).value
      : "";
    cols.push({
      ...canonical,
      mapType,
      mappedTo,
      isCustom,
      mappedValue,
    });
  }

  return cols;
};

// -------------------------------------------------------
// -------------------------------------------------------
export const excludeCollection = (collectionid) => (dispatch) => {
  dispatch({ type: "EXCLUDE_COLLECTION", collectionid });
  //dispatch(saveProject());
};
